export const CONFIG_MODULES = [
  // --- GEOGRAPHY ---
  { id: 'states', group: 'Geography', label: 'States', endpoint: '/states', pk: 'id' },
  { id: 'cities', group: 'Geography', label: 'Cities', endpoint: '/cities', pk: 'id' },
  { id: 'subregisters', group: 'Geography', label: 'Sub Registers', endpoint: '/subregisters', pk: 'id' },
  { id: 'nearestLocation', group: 'Geography', label: 'Nearest Locations', endpoint: '/nearest-location', pk: '_id' },
  
  // --- PROPERTY / PROJECT STRUCTURE ---
  { id: 'categories', group: 'Real Estate', label: 'Property Categories', endpoint: '/category', pk: '_id' },
  { id: 'propertyTypes', group: 'Real Estate', label: 'Property Types', endpoint: '/types/property', pk: 'id' },
  { id: 'projectTypes', group: 'Real Estate', label: 'Project Types', endpoint: '/types/project', pk: 'id' },
  { id: 'listingTypes', group: 'Real Estate', label: 'Listing Types', endpoint: '/listing-types', pk: 'id' },
  { id: 'landtype', group: 'Real Estate', label: 'Land Types', endpoint: '/landtype', pk: 'id' },
  { id: 'amenities', group: 'Real Estate', label: 'Amenities', endpoint: '/amenities', pk: '_id' },
  { id: 'amenities_cat', group: 'Real Estate', label: 'Amenities Categories', endpoint: '/amenities-category', pk: '_id' },
  { id: 'propertyDetail', group: 'Real Estate', label: 'Property Details config', endpoint: '/property-detail', pk: 'id' },
  { id: 'propertyBlock', group: 'Real Estate', label: 'Property Blocks', endpoint: '/property-blocks', pk: 'id' },
  { id: 'propertyInput', group: 'Real Estate', label: 'Property Inputs', endpoint: '/property-inputs', pk: 'id' },
  { id: 'projectBlock', group: 'Real Estate', label: 'Project Blocks', endpoint: '/project-blocks', pk: 'id' },
  { id: 'projectInput', group: 'Real Estate', label: 'Project Inputs', endpoint: '/project-inputs', pk: 'id' },
  { id: 'bookingForm', group: 'Real Estate', label: 'Booking Form', endpoint: '/booking-form', pk: 'id' },
  { id: 'filter', group: 'Real Estate', label: 'Filters', endpoint: '/filter', pk: '_id' },
  
  // --- SETTINGS & ACTIONS ---
  { id: 'dropdown', group: 'Settings', label: 'Dropdown Options', endpoint: '/dropdown', pk: 'id' },
  { id: 'roles', group: 'Settings', label: 'Roles', endpoint: '/roles', pk: 'id' },
  { id: 'settings', group: 'Settings', label: 'Global Settings', endpoint: '/settings', pk: '_id' },
  { id: 'loginInput', group: 'Settings', label: 'Login Inputs', endpoint: '/login-input', pk: 'id', crudMode: 'singleton-put' },
  { id: 'navLink', group: 'Settings', label: 'Navigation Links', endpoint: '/nav-links', pk: 'id' },
  { id: 'enquiry', group: 'Settings', label: 'Raw Enquiries', endpoint: '/enquiry', pk: 'id' },
  { id: 'booking', group: 'Settings', label: 'Raw Bookings', endpoint: '/booking', pk: 'id' },
  
  // --- CONTENT & CMS ---
  { id: 'hero', group: 'CMS', label: 'Hero Section', endpoint: '/hero', pk: '_id', crudMode: 'singleton-post' },
  { id: 'homeSection', group: 'CMS', label: 'Home Sections', endpoint: '/home-sections', pk: '_id' },
  { id: 'aboutus', group: 'CMS', label: 'About Us', endpoint: '/aboutus', pk: '_id' },
  { id: 'privacy', group: 'CMS', label: 'Privacy Policy', endpoint: '/content/privacy', pk: '_id', crudMode: 'singleton-put-no-delete' },
  { id: 'terms', group: 'CMS', label: 'Terms & Conditions', endpoint: '/content/terms', pk: '_id', crudMode: 'singleton-put-no-delete' },
  { id: 'ads', group: 'CMS', label: 'Advertisements', endpoint: '/ads', pk: '_id' },
  { id: 'contact', group: 'CMS', label: 'Contact Info', endpoint: '/contact', pk: 'id', crudMode: 'singleton-post' },
  { id: 'footer', group: 'CMS', label: 'Footer Links', endpoint: '/footer', pk: 'id', crudMode: 'singleton-post' },
  { id: 'socialMedia', group: 'CMS', label: 'Social Media', endpoint: '/social-media', pk: 'id' },
  { id: 'whyChoose', group: 'CMS', label: 'Why Choose Us', endpoint: '/why-choose', pk: 'id', crudMode: 'singleton-post' },
  { id: 'youtubeShorts', group: 'CMS', label: 'Youtube Shorts', endpoint: '/youtube-shorts', pk: 'id', crudMode: 'singleton-post' }
];

export const MODULE_FIELDS = {
  propertyBlock: [
    { key: 'block_name', label: 'Block Name', type: 'text' },
    { key: 'block_key', label: 'Block Key', type: 'text' },
    { key: 'block_icon', label: 'Block Icon', type: 'text' },
    { key: 'block_type', label: 'Block Type', type: 'text' },
    { key: 'is_property_show', label: 'Is Property Show', type: 'boolean' },
    { key: 'is_project_show', label: 'Is Project Show', type: 'boolean' },
    { key: 'field_keys', label: 'Field Keys', type: 'array' },
    { key: 'enable_toggle', label: 'Enable Toggle', type: 'boolean' },
    { key: 'toggle_field', label: 'Toggle Field', type: 'text' },
    { key: 'default_enabled', label: 'Default Enabled', type: 'boolean' },
  ],
  projectBlock: [
    { key: 'block_name', label: 'Block Name', type: 'text' },
    { key: 'block_key', label: 'Block Key', type: 'text' },
    { key: 'block_icon', label: 'Block Icon', type: 'text' },
    { key: 'block_type', label: 'Block Type', type: 'text' },
    { key: 'is_project_show', label: 'Is Project Show', type: 'boolean' },
    { key: 'is_property_show', label: 'Is Property Show', type: 'boolean' },
    { key: 'field_keys', label: 'Field Keys', type: 'array' },
    { key: 'enable_toggle', label: 'Enable Toggle', type: 'boolean' },
    { key: 'toggle_field', label: 'Toggle Field', type: 'text' },
    { key: 'default_enabled', label: 'Default Enabled', type: 'boolean' },
  ],
};

// Helper to determine field type based on key name and value type
export const getFieldType = (key, value) => {
  if (typeof value === 'boolean') return 'boolean';
  if (key.startsWith('is_') || key.endsWith('_show') || key.startsWith('enable_') || key === 'default_enabled') {
    return 'boolean';
  }
  if (typeof value === 'number') return 'number';
  if (Array.isArray(value) || (typeof value === 'object' && value !== null)) return 'array';
  if (key.includes('image') || key.includes('icon') || key.includes('logo')) return 'image';
  if (key.includes('description') || key.includes('content') || key.includes('text')) return 'textarea';
  return 'text';
};
